
import React, { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { FeatureFlag } from '../../featureFlags';
import { flags } from '../../featureFlags/flags';
import { useFeatureFlag } from '../../featureFlags';
import { Layout, List } from 'antd';
import { PageHeader } from '@ant-design/pro-layout';
import { DataExportItem } from './DataExportItem';
import './styles.less';
import { Section } from '../../components/section/Section';
import { Routes } from '../../routes';
import { buildPageHeaderBreadcrumb } from '../../updated/utils'; 
import { GET_REPORT_HISTORY } from '../../gql/queries/GET_REPORT_HISTORY';
import { GET_REPORT_TYPES_QUERY } from '../../gql';
import GeneralErrorView from '../GeneralErrorView';
import NotFoundErrorView from '../NotFoundErrorView';

const DataExportView = ( ) => {
    const { data, loading, error } = useQuery( GET_REPORT_TYPES_QUERY, {  fetchPolicy: 'network-only' }  );
    const { data: history, loading: historyLoading } = useQuery( GET_REPORT_HISTORY, {  fetchPolicy: 'network-only' }  );
    const showContentMasterReport = useFeatureFlag( { name: flags.SHOW_CONTENT_MASTER_REPORT } );
    
    const reportsData = useMemo( () => {
        if ( !data ) {return [];}

        const result =  data.reportTypes.edges.map( edge => ( {
            name: edge.node.reportLabel,
            type: edge.node.reportType,
            description: edge.node.reportDescription
        } ) );

        if ( showContentMasterReport ) {
            return result;
        } else {
            return result.filter( i => i.type !== 'CONTENT_MASTER_REPORT' );
        }
    }, [ data ] );

    const historyData = useMemo( () => {
        if ( !history || !reportsData || reportsData === [] ) {return {};}
        
        const ret = {};
        reportsData.forEach( report => ret[ report.type ] = [] );
        history.reports.edges.forEach( edge => ret[ edge.node.reportType ]?.unshift( edge.node ) );

        return ret;

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ historyLoading, reportsData ] );

    return (
        <FeatureFlag name={ flags.DATA_EXPORT } fallback={ <NotFoundErrorView />    }>
            {
                error 
                    ? <GeneralErrorView 
                        title='Oops!' message='Something went wrong'
                        route={ Routes.DataExportPage.buildPath() } buttonText='Refresh'/> 
                    : <Layout className="page-data-export">
                    
                        { /* Breadcrumbs */ }
                
                        <PageHeader
                            breadcrumb={ buildPageHeaderBreadcrumb( [
                                { breadcrumbName: 'Course Studio', path: Routes.Home.buildPath() },
                                { breadcrumbName: 'Analytics', path: Routes.Reporting.buildPath() },
                                { breadcrumbName: 'Data Export', path: Routes.DataExportPage.buildPath() }
                            ] ) } 
                        />

                        <Section
                            card
                            title="Data Export">

                            <List
                                size="large" 
                                bordered
                                loading={ loading }
                                dataSource={ reportsData }
                                renderItem={ ( item ) => 
                                    <DataExportItem 
                                        { ...item }
                                        history={ historyData[ item.type ] }
                                        historyLoading={ historyLoading } /> }
                            />
                        </Section>
                    </Layout> }
        </FeatureFlag>
    );
};

export default DataExportView;
